import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { IconButton } from "@mui/material";
import { useState } from "react";
import { ManageDocumentProductsDialog } from "../../../page/DocumentsPage/ManageDocumentProductsDialog";
import { useUpdateDocumentProducts } from "../../../services/documentsService";

const ManageRelatedProductsButton = ({
    documentData,
    initialSelectedProductIds = [],
    onUpdate,
}) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const updateDocumentProducts = useUpdateDocumentProducts();

    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleDialogConfirm = async (productIds) => {
        if (documentData?.id) {
            try {
                await updateDocumentProducts.mutateAsync({
                    document_id: documentData.id,
                    product_ids: productIds,
                });
                setDialogOpen(false);
                onUpdate?.();
            } catch (error) {
                console.error("Failed to update document products:", error);
            }
        }
    };

    return (
        <>
            <IconButton
                color="primary"
                onClick={handleClick}
                size="small"
                disabled={updateDocumentProducts.isPending}
            >
                <AccountTreeIcon />
            </IconButton>
            {dialogOpen && (
                <ManageDocumentProductsDialog
                    open={dialogOpen}
                    onClose={handleDialogClose}
                    onConfirm={handleDialogConfirm}
                    documentData={documentData}
                    initialSelectedProductIds={initialSelectedProductIds}
                    isLoading={updateDocumentProducts.isPending}
                />
            )}
        </>
    );
};

export default ManageRelatedProductsButton;
